import angular from 'angular';
import '../../services/organization-scenario';
import '../../services/organization-segment';
import '../../services/organization-condition';
import '../../services/errors';
import { cloneDeep, get } from 'lodash';

const module = angular.module('whyline.modals.organization-scenario', [
  'whyline.services.organization-scenario',
  'whyline.services.organization-condition',
  'whyline.services.errors',
]);

const OrganizationScenarioModalController = (
  $scope,
  $timeout,
  $uibModalInstance,
  $translate,
  NotificationService,
  OrganizationScenarioService,
  organizationScenarioId,
  ErrorService,
  OrganizationSegmentService,
  OrganizationConditionService,
) => {
  'ngInject';

  $scope.blockSaveButton = false;

  $scope.string = { scenarioString: '' };

  $scope.conditions = [];

  $scope.segments = [];

  $scope.scenario = {
    name: '',
    alias: '',
    conditionId: '',
    weight: '',
    segmentId: '',
  };

  OrganizationSegmentService.GetAllAsPromise().then((segments) => {
    $scope.segments = segments;
    $scope.segmentSelected = $scope.segments[0];
    OrganizationConditionService.GetAllAsPromise().then((conditions) => {
      $scope.conditions = conditions;
      $scope.conditionSelected = $scope.conditions[0];
      if (organizationScenarioId) {
        OrganizationScenarioService.GetOneAsPromise(organizationScenarioId).then((scenario) => {
          $timeout(() => {
            $scope.scenario = cloneDeep(scenario);
            $scope.string.scenarioString = JSON.stringify(scenario.scenario);
            $scope.segmentSelected = get($scope.segments, $scope.scenario.segmentId, '');
            $scope.conditionSelected = get($scope.conditions, $scope.scenario.conditionId, '')
          });
        });
      }
    });
    
  });

  $scope.setSegmentId = segmentSelected => {
    $scope.scenario.segmentId = segmentSelected._id;
  };

  $scope.setConditionId = conditionSelected => {
    $scope.scenario.conditionId = conditionSelected._id;
  };

  const validate = () => {
    if (!$scope.scenario.name) {
      NotificationService.Warning($translate.instant('scenario_name_required'));
      return false;
    }

    if($scope.scenario.name.length > 56){
      NotificationService.Warning($translate.instant('scenario_name_max_length'));
      return false;
    }

    if(!$scope.scenario.weight){
      NotificationService.Warning($translate.instant('scenario_weight_required'));
      return false;
    }

    if(!$scope.scenario.segmentId){
      NotificationService.Warning($translate.instant('scenario_segment_required'));
      return false;
    }

    if(!$scope.scenario.conditionId){
      NotificationService.Warning($translate.instant('scenario_condition_required'));
      return false;
    }

    if (!/^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/.test($scope.scenario.name)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    return true;
  };

  $scope.close = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.save = () => {
    if (validate()) {
      const { name } = $scope.scenario;
      $scope.blockSaveButton = true;
      let message = '';
      let promise = null;
      if (organizationScenarioId) {
        message = $translate.instant('scenario_update_succ');
        promise = OrganizationScenarioService.Update($scope.scenario);
      } else {
        message = $translate.instant('scenario_create_succ');
        promise = OrganizationScenarioService.Create($scope.scenario);
      }

      promise.then(() => {
        NotificationService.Success(message.replace('{name}', name));

        $uibModalInstance.close('cancel');
      });

      return promise.catch((err) => {
        $scope.blockSaveButton = false;

        if (err && err.status === 406) {
          const { data: reason } = err;

          const message = $translate.instant(reason);

          NotificationService.Warning(message);
        } else {
          ErrorService.handler(err);
        }
      });
    }
  };
};

module.exports = module.controller(
  'OrganizationScenarioModalController',
  OrganizationScenarioModalController,
);
